import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SiteHeader } from "../../components/site/SiteHeader";
import { SiteFooter } from "../../components/site/SiteFooter";
import { PageHero } from "../../components/site/PageHero";
import { CTABand } from "../../components/site/CTABand";
import { Reveal, Stagger, StaggerItem } from "../../components/motion/Reveal";
import { INDUSTRY_DETAILS } from "../../data/industries";

export default function IndustriesIndex() {
  return (
    <div className="font-publicsans bg-nx-navy text-slate-200 antialiased" data-testid="industries-page">
      <SiteHeader />
      <PageHero
        crumb="Industries"
        eyebrow="Industries"
        title="Engineered for"
        titleAccent="your environment."
        description="Each industry places its own demands on infrastructure. We design for the environment you operate in — not a generic template."
      />
      <section className="py-16 sm:py-24">
        <div className="nx-wrap">
          <Reveal className="mb-12">
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 sm:col-span-7 border border-nx-gold/25 p-2">
                <img src="https://images.unsplash.com/photo-1596541223130-5d31a73fb6c6?auto=format&fit=crop&w=1000&q=70" alt="Indian commercial complex at dusk" className="w-full h-52 sm:h-64 object-cover" loading="lazy" />
              </div>
              <div className="col-span-12 sm:col-span-5 border border-white/10 p-2 sm:mt-10">
                <img src="https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=800&q=70" alt="Modern open office workspace" className="w-full h-40 sm:h-52 object-cover" loading="lazy" />
              </div>
            </div>
          </Reveal>
          <Stagger className="grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
            {INDUSTRY_DETAILS.map((ind, i) => (
              <StaggerItem key={ind.slug}>
                <Link to={`/industries/${ind.slug}`} className="group flex h-full flex-col bg-nx-navy hover:bg-nx-navy2 p-7 sm:p-9 transition-colors duration-300" data-testid={`industry-card-${ind.slug}`}>
                  <div className="flex items-start justify-between">
                    <span className="font-marcellus text-nx-gold/60 text-lg">{String(i + 1).padStart(2, "0")}</span>
                    <ArrowUpRight size={18} className="text-slate-600 group-hover:text-nx-goldlight group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                  </div>
                  <h2 className="font-marcellus text-xl sm:text-2xl text-white mt-6">{ind.name}</h2>
                  <p className="text-sm text-slate-400 mt-3 leading-relaxed flex-1">{ind.intro}</p>
                  <span className="block mt-7 h-px w-8 bg-nx-gold/50 group-hover:w-full transition-all duration-500" />
                </Link>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>
      <CTABand />
      <SiteFooter />
    </div>
  );
}
